var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("x-grid", {
        ref: "grid",
        attrs: {
          id: "formList",
          rowId: _vm.rowId,
          "pager-config": _vm.pagerConfig,
          "form-config": _vm.formConfig,
          url: _vm.url,
          columns: _vm.columns,
          "checkbox-config": _vm.checkboxConfig,
          "toolbar-config": _vm.toolbarConfig,
          "print-config": _vm.printConfig,
          "import-config": _vm.importConfig,
          "export-config": _vm.exportConfig,
          otherParams: { fissionId: _vm.fissionId },
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.toolbarConfig.templatelSlots,
              fn: function () {
                return [
                  _c("vxe-button", { on: { click: _vm.send } }, [
                    _vm._v("已兑奖"),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }